import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import Link from '@src/components/link';
import SuccessModalStore from './store';

const styles = require('./index.less');

/**
 * 弹窗模板, 可以快速套用修改
 */
const SuccessModal = ({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={cx(styles.commonDemoModalRoot)}>
        <Link className={styles.closeBtn} onClick={store.onClickClose} />
        <div className={styles.modalContainer}>
          <div className={styles.title}>
            下载游戏，获取官方<span>[新岁启程补给]</span>
          </div>
          <div className={styles.desc}>
            恭喜您获得尘白禁区官方新岁启程补给，礼包码为：<span className={styles.code}>{store.cdk}</span>
            <Link onClick={store.copy}>【复制礼包码】</Link>
            <br />
            点击下载或者扫描二维码均可下载客户端，可在游戏-设置-其他设置-前往兑换中，输入礼包码兑换奖励。
          </div>
          <div className={styles.qrcodeBox}>
            <div className={styles.qr} />
          </div>
        </div>
        <Link className={styles.confirm} onClick={store.download} />
      </div>
    </ModalContainer>
  );
};

export default wrapStore(SuccessModal, SuccessModalStore);
